import { GatewayTranslator } from '../translators/gateway_translator';
import { ITabViewTranslator } from "../translators/itranslator";
import { IClientConfig } from "../data_manager/data_manager_factory";
import { AjaxHelper } from "../../http/ajax_helper";
import { IAlbumsConfig, IGatewayAlbumDataManager } from '../photo/iphoto_data_manager';

export class GatewayAlbumDataManager implements IGatewayAlbumDataManager{
    private translator: ITabViewTranslator;
    private discoveryEndPoints: any;

    constructor(config: IClientConfig) {
      this.translator = new GatewayTranslator();
      this.discoveryEndPoints = config.discoveryEndPoints;
    }
    /**
     * Method is use to get the user selected source shared albums
     * @param config 
     */   
    makeSharedAlbumsCall(config: IAlbumsConfig) {
        var url = `/v1/gw/sharedAlbums?source=${config.source}&size=${config.pageSize}`
        if(config.pageToken){
          url +=`&pageToken=${config.pageToken}`
        }
        let reqConfig = {
          url: this.discoveryEndPoints.libraryService + '/request_api',
          type: "POST",
          data: JSON.stringify({uriTemplate: `/v1/gw/sharedAlbums`,version: "v1", type: "GET", req_service: "pascal", url: url }),
          ignoreAToken: true,
          ignoreResCaching: true,
          cache:true
        };
        const promise =  AjaxHelper.triggerApi(
          {requestConfig: reqConfig},this.translator.translateAlbums.bind(this.translator,config))
        return promise;
    }
    /**
     * Method is use to get the user selected source owned albums
     * @param config 
     */
    makeOwnedAlbumsCall(config: IAlbumsConfig) {
      var url = `/v1/gw/albums?source=${config.source}&size=${config.pageSize}`
      if(config.pageToken){
        url +=`&pageToken=${config.pageToken}`
      }
      let reqConfig = {
        url: this.discoveryEndPoints.libraryService + '/request_api',
        type: "POST",
        data: JSON.stringify({uriTemplate: `/v1/gw/albums`,version: "v1", type: "GET", req_service: "pascal", url: url }),
        ignoreAToken: true,
        ignoreResCaching: true,
        cache:true
      };
      const promise =  AjaxHelper.triggerApi(
        {requestConfig: reqConfig},this.translator.translateAlbums.bind(this.translator,config))
      return promise;
  }
}